/* unplugin-vue-components disabled */import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=7735fe57&lang=scss"

const __exports__ = script;

export default __exports__